import { useQuery } from '@tanstack/react-query';
import { searchNotifications } from '../services/notificationService';
import { Notification } from '../types/notification.types';

export const useNotificationSearch = (
  userId: number,
  notificationStatusId?: number
) => {
  // Siempre enviar notificationStatusId como array si está definido
  const params: { userId: number; notificationStatusId?: number[] } = { userId };
  if (notificationStatusId !== undefined) {
    params.notificationStatusId = [notificationStatusId];
  }

  const query = useQuery({
    queryKey: ['notifications-search', userId, notificationStatusId],
    queryFn: () => searchNotifications(params),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: true,
    enabled: !!userId,
  });

  const isLoading = query.isLoading;
  const isError = query.isError;
  const error = query.error;
  const notifications: Notification[] = query.data ?? [];

  return { notifications, isLoading, isError, error };
}; 